import React from "react";
import "./MessagePopup.scss";
import { Form, Input, Button } from "semantic-ui-react";
import TwilioService from "../../services/twilioService";
import toastr from "toastr";
import { createZendeskIdValidator } from "../../utils/useZendeskIdValidator";

class MessagePopup extends React.Component {
  constructor(props) {
    super(props);
    const { phoneNumber = "", zendeskId = "" } = props;
    this.state = {
      phoneNumber: phoneNumber,
      zendeskID: zendeskId,
      message: "",
      errorPhoneNumber: false,
      errorMessage: false,
      errorZendeskID: false,
      existZendeskID: !!zendeskId,
      existApplicant: !!zendeskId,
      zendeskIDStatus: zendeskId ? "check" : "",
      sending: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    const { onSearch$, cleanup } = createZendeskIdValidator(this);
    this.onSearch$ = onSearch$;
    this.cleanupValidator = cleanup;
  }
  componentWillUnmount() {
    this._isMounted = false;
    if (this.cleanupValidator) {
      this.cleanupValidator();
    }
  }

  async sendMessage(event) {
    event.stopPropagation();
    const { phoneNumber, message, zendeskID, existZendeskID } = this.state;
    if (!phoneNumber) {
      this.setState({ errorPhoneNumber: true });
      toastr.error("Phone number is required.", "Error");
      return;
    }
    if (!message) {
      this.setState({ errorMessage: true });
      return;
    }
    const isZendeskLoading = this.state.zendeskIDStatus === "loading";
    if (isZendeskLoading) {
      toastr.warning("Zendesk ID is still being verified. Please wait.", "Warning");
      return;
    }
    if (!zendeskID || !existZendeskID) {
      this.setState({ errorZendeskID: true });
      toastr.error("Valid Zendesk ID is required.", "Error");
      return;
    }
    this.setState({ sending: true });
    try {
      await TwilioService.sendSMS(phoneNumber, message, {
        zendeskId: zendeskID,
        product: this.props.product,
      });
      toastr.success("SMS sent successfully.");
      this.props.closeModal();
    } catch (error) {
      // Error toasts are handled by TwilioService
      if (this._isMounted) {
        this.setState({ sending: false });
      }
    }
  }

  phoneNumberChanged(value) {
    if (/^\+?[0-9 ]*$/.test(value)) {
      this.setState({
        phoneNumber: value.replace(/ {2}/, " "),
      });
      if (value) {
        this.setState({ errorPhoneNumber: false });
      }
    }
  }

  messageChanged(value) {
    this.setState({ message: value });
    if (value) {
      this.setState({ errorMessage: false });
    }
  }

  zendeskIDChanged(value) {
    if (value) {
      this.setState({ errorZendeskID: false });
    }
  }

  renderMessagePopup() {
    const { phoneNumber, message } = this.state;

    return (
      <div className="sk-message-popup-container">
        <Form className="sk-message-popup-form">
          <div className="sk-dial-pad-input-numbers">
            <Input
              name="phoneNumber"
              value={phoneNumber}
              onChange={(event) => {
                this.setState({ phoneNumber: event.target.value });
                this.phoneNumberChanged(event.target.value);
              }}
              type="type"
              label="Phone number:"
              size="small"
              error={this.state.errorPhoneNumber}
            ></Input>
            <Input
              icon={
                this.state.zendeskIDStatus === "check"
                  ? "check"
                  : this.state.zendeskIDStatus === "delete"
                  ? "delete"
                  : ""
              }
              loading={this.state.zendeskIDStatus === "loading" ? true : false}
              name="zendeskID"
              value={this.state.zendeskID}
              onChange={(event) => {
                this.onSearch$.next(event.target.value);
              }}
              label="Zendesk ID: "
              size="small"
              error={this.state.errorZendeskID}
              ref={this.zendeskIDRef}
            ></Input>
          </div>
          <div className="sk-message-popup-textarea-container">
            <Form.TextArea
              value={message}
              onChange={(event) => this.messageChanged(event.target.value)}
              rows={10}
              placeholder="Text message"
              error={this.state.errorMessage}
            ></Form.TextArea>
          </div>

          <div className="sk-message-button-group">
            <Button
              className="sk-message-send-button"
              onClick={(event) => this.sendMessage(event)}
              disabled={this.state.sending}
              loading={this.state.sending}
            >
              Send
            </Button>
            <Button
              className="sk-message-cancel-button"
              onClick={() => this.props.closeModal()}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    );
  }

  render() {
    return (
      <div className="sk-message-popup-modal">{this.renderMessagePopup()}</div>
    );
  }
}

export default MessagePopup;
